import {
    Button,
    Checkbox,
    Col,
    DatePicker,
    Descriptions,
    Form,
    Input,
    InputNumber,
    Popconfirm,
    Row,
    Select,
    Space,
    Spin,
} from "antd";
import React, { useEffect, useState } from "react";
import axios from "axios";
import axiosInstance from "../common/api";
import { filterOption, requiredField } from "../common/common";
import { useForm } from "antd/lib/form/Form";
import dayjs from "dayjs";
import { NumericFormat } from "react-number-format";
import MoneyInput from "../common/MoneyInput";

const periodOptions = [
    "GENNAIO",
    "FEBBRAIO",
    "MARZO",
    "APRILE",
    "MAGGIO",
    "GIUGNO",
    "LUGLIO",
    "AGOSTO",
    "SETTEMBRE",
    "OTTOBRE",
    "NOVEMBRE",
    "DICEMBRE",
    "TREDICESIMA",
    "QUATTORDICESIMA",
].map((x) => ({ value: x }));

export default function ConfirmPaycheck({ data, onFinish }) {
    const [employees, setEmployees] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pdfData, setPdfData] = useState(undefined);
    const [form] = useForm();
    const [confirmLoading, setConfirmLoading] = useState(false);

    useEffect(() => {
        axiosInstance.get("employeeCompact?activeOnly=false").then(({ data }) => {
            setEmployees(data);
        });
    }, []);

    useEffect(() => {
        setLoading(true);
        axiosInstance
            .get(`paycheck/${data.id}/file?tmp=true`, { responseType: "blob" })
            .then((response) => {
                const blob = new Blob([response.data], { type: "application/pdf" });
                const dataUrl = window.URL.createObjectURL(blob);
                setPdfData(dataUrl);
                form.setFieldsValue({
                    ...data,
                    hasTfr: false,
                    sendMail: true,
                });
            })
            .finally(() => setLoading(false));
    }, [data]);

    useEffect(() => {
        if (!!data && employees.length > 0)
            form.setFieldValue(
                "email",
                employees.filter((x) => x.id === data.employee)[0]?.email ?? undefined,
            );
    }, [data, employees]);

    useEffect(() => {
        if (!!pdfData && !!employees) setLoading(false);
    }, [pdfData, employees]);

    const confirmPaycheck = (form) => {
        setConfirmLoading(true);
        axiosInstance
            .put("paycheck/" + data.id, {
                ...form,
                isTmp: true,
            })

            .then(() => onFinish?.())
            .finally(() => setConfirmLoading(false));
    };

    const deletePaycheck = () => {
        axiosInstance.delete("paycheck/" + data.id + "?tmp=true").then(() => onFinish?.());
    };

    return (
        <Spin spinning={loading}>
            <Row gutter={20}>
                <Col span={16}>
                    <iframe src={pdfData} style={{ width: "100%", height: 700 }}>
                        ciao
                    </iframe>
                </Col>
                <Col span={8}>
                    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
                        <Descriptions
                            column={3}
                            title="Dati estratti"
                            layout="vertical"
                            style={{ flex: 1 }}
                            colon={false}
                            bordered
                        >
                            <Descriptions.Item label="Dipendente" span={2}>
                                {data.employee?.fullName}
                            </Descriptions.Item>
                            <Descriptions.Item label="Periodo">
                                {data.period} {data.year}
                            </Descriptions.Item>
                            <Descriptions.Item label="Importo lordo">
                                {data.gross.toLocaleString("it-IT", {
                                    minimumFractionDigits: 2,
                                    useGrouping: true,
                                })}
                            </Descriptions.Item>
                            <Descriptions.Item label="Importo netto">
                                {data.net.toLocaleString("it-IT", {
                                    minimumFractionDigits: 2,
                                    useGrouping: true,
                                })}
                            </Descriptions.Item>
                            <Descriptions.Item label="TFR">
                                {{ SETTLEMENT: "Liquidazione", ADVANCE: "Anticipo" }[
                                    data.tfrType
                                ] ?? ""}
                            </Descriptions.Item>
                        </Descriptions>
                        <div style={{ flex: "auto", placeContent: "end" }}>
                            <Form layout={"vertical"} form={form} onFinish={confirmPaycheck}>
                                <Form.Item name={["employee", "email"]} label="E-Mail">
                                    <Input disabled />
                                </Form.Item>
                                <Form.Item
                                    rules={[requiredField]}
                                    name={"sendMail"}
                                    valuePropName={"checked"}
                                >
                                    <Checkbox>Invia cedolino via e-mail</Checkbox>
                                </Form.Item>
                                <Form.Item>
                                    <Space wrap>
                                        <Popconfirm
                                            title={"Operazione irreversibile"}
                                            style={{ maxWidth: 250 }}
                                            description={"Il cedolino verrà eliminato. Confermare?"}
                                            onConfirm={deletePaycheck}
                                        >
                                            <Button>Scarta</Button>
                                        </Popconfirm>
                                        <Button
                                            loading={confirmLoading}
                                            type={"primary"}
                                            htmlType={"submit"}
                                        >
                                            Conferma e vai al successivo
                                        </Button>
                                    </Space>
                                </Form.Item>
                            </Form>
                        </div>
                    </div>
                </Col>
            </Row>
        </Spin>
    );
}
